import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';

export default function YouthStartupPage() {
  const [scrolled, setScrolled] = useState(false);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-orange-50 via-white to-amber-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center gap-3 mb-6">
            <Link to="/" className="text-gray-500 hover:text-orange-500 transition-colors">
              <i className="ri-home-line"></i>
            </Link>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <Link to="/services" className="text-gray-500 hover:text-orange-500 transition-colors">
              服務方案
            </Link>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <span className="text-orange-600 font-medium">青年創業專案</span>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <span className="inline-block bg-orange-500 text-white text-sm font-semibold px-4 py-2 rounded-full mb-6">
                <i className="ri-rocket-line mr-2"></i>創業首選
              </span>
              <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                青年創業專案
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed mb-8">
                專為青年創業者設計，提供低利、免保人、前期只付利息之優惠方案，協助青年圓夢創業。
              </p>
              <div className="flex flex-wrap gap-4">
                <Link
                  to="/contact"
                  className="px-8 py-4 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-lg font-semibold hover:from-orange-600 hover:to-orange-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                >
                  立即諮詢此方案
                </Link>
                <a
                  href="https://line.me/R/ti/p/@678gwbht"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-8 py-4 bg-[#06C755] text-white rounded-lg font-semibold hover:bg-[#05b34c] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer flex items-center gap-2"
                >
                  <i className="ri-line-fill text-xl"></i>
                  LINE 諮詢
                </a>
              </div>
            </div>
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/5638f8a901f5337c52198335f48b13da.jpg"
                alt="青年創業"
                className="w-full h-[400px] object-cover rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* 專案概述 */}
      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-6 lg:px-8">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-8">
            一、青年創業專案
          </h2>
          
          <div className="space-y-12">
            {/* 專案概述 */}
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-2 h-8 bg-orange-500 mr-4"></div>
                專案概述
              </h3>
              <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-8 border-2 border-orange-100">
                <p className="text-gray-700 leading-relaxed mb-4">
                  青年創業貸款是政府為協助青年投入創業、降低初期融資門檻所設計的政策性融資方案，主要透過合作金融機構提供資金，並搭配政府利息補貼及信用保證機制，協助青年創業者在創業初期順利取得營運所需資金。
                </p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  此方案重點不在於補助，而在於協助具可行商業模式的青年創業者建立正式的銀行往來與信用紀錄。
                </p>
                <p className="text-gray-700 leading-relaxed">
                  青年創業貸款是一項結合政府政策支持、銀行融資與信用保證機制的創業融資方案，目的在協助青年創業者於創業初期順利取得資金，並逐步建立企業信用基礎。
                </p>
              </div>
            </div>

            {/* 制度設計重點說明 */}
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-2 h-8 bg-orange-500 mr-4"></div>
                制度設計重點說明
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-orange-300 transition-all">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-bank-line text-2xl text-orange-600"></i>
                    </div>
                    <div>
                      <h4 className="text-lg font-bold text-gray-900 mb-2">資金來源</h4>
                      <p className="text-gray-600 text-sm leading-relaxed">
                        由合作銀行承作放款，政府提供政策支持
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-orange-300 transition-all">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-shield-check-line text-2xl text-orange-600"></i>
                    </div>
                    <div>
                      <h4 className="text-lg font-bold text-gray-900 mb-2">信用輔助</h4>
                      <p className="text-gray-600 text-sm leading-relaxed">
                        可搭配中小企業信用保證基金提供信用保證，降低銀行授信風險
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-orange-300 transition-all">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-government-line text-2xl text-orange-600"></i>
                    </div>
                    <div>
                      <h4 className="text-lg font-bold text-gray-900 mb-2">政策支持</h4>
                      <p className="text-gray-600 text-sm leading-relaxed">
                        視個案條件提供利息補貼或優惠利率
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-orange-300 transition-all">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-money-dollar-circle-line text-2xl text-orange-600"></i>
                    </div>
                    <div>
                      <h4 className="text-lg font-bold text-gray-900 mb-2">融資性質</h4>
                      <p className="text-gray-600 text-sm leading-relaxed">
                        屬於貸款，非補助，須依約還款
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 適用對象 */}
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-2 h-8 bg-orange-500 mr-4"></div>
                適用對象
              </h3>
              <div className="bg-white rounded-2xl p-8 border-2 border-gray-200">
                <p className="text-gray-700 leading-relaxed mb-6">
                  青年創業貸款主要適用於：
                </p>
                <ul className="space-y-4">
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 text-xl mt-0.5 flex-shrink-0"></i>
                    <span className="text-gray-700">年齡符合政府規定之青年創業者</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 text-xl mt-0.5 flex-shrink-0"></i>
                    <span className="text-gray-700">已完成公司或商業登記，或正處於創業初期階段</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 text-xl mt-0.5 flex-shrink-0"></i>
                    <span className="text-gray-700">具備明確營運規劃、商業模式及資金用途說明</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 text-xl mt-0.5 flex-shrink-0"></i>
                    <span className="text-gray-700">尚未累積完整財報或擔保品之新創或小型企業</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* 可運用的資金用途 */}
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-2 h-8 bg-orange-500 mr-4"></div>
                可運用的資金用途
              </h3>
              <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border-2 border-gray-200">
                <p className="text-gray-700 leading-relaxed mb-6">
                  青年創業貸款之資金，通常可用於與營運直接相關的支出，包括：
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-orange-500 text-xl mt-0.5 flex-shrink-0"></i>
                    <span className="text-gray-700">創業初期營運週轉金</span>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-orange-500 text-xl mt-0.5 flex-shrink-0"></i>
                    <span className="text-gray-700">設備、機器及必要營業資產購置</span>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-orange-500 text-xl mt-0.5 flex-shrink-0"></i>
                    <span className="text-gray-700">店面裝修、系統建置等資本性支出</span>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-orange-500 text-xl mt-0.5 flex-shrink-0"></i>
                    <span className="text-gray-700">與營運發展相關之合理費用</span>
                  </div>
                </div>
              </div>
            </div>

            {/* 與一般企業貸款的差異 */}
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-2 h-8 bg-orange-500 mr-4"></div>
                與一般企業貸款的差異
              </h3>
              <div className="bg-white rounded-2xl p-8 border-2 border-gray-200">
                <p className="text-gray-700 leading-relaxed mb-6">
                  相較一般商業貸款，青年創業貸款具備以下特色：
                </p>
                <div className="space-y-4">
                  <div className="flex items-start gap-4 p-4 bg-orange-50 rounded-lg">
                    <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-white text-lg"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-1">較低的融資門檻</h4>
                      <p className="text-gray-600 text-sm">降低創業初期申請難度</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4 p-4 bg-orange-50 rounded-lg">
                    <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-white text-lg"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-1">可搭配政府信用保證</h4>
                      <p className="text-gray-600 text-sm">降低擔保壓力，提高核貸機會</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4 p-4 bg-orange-50 rounded-lg">
                    <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-white text-lg"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-1">彈性審查標準</h4>
                      <p className="text-gray-600 text-sm">對企業成立年限與財報要求相對彈性</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4 p-4 bg-orange-50 rounded-lg">
                    <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-white text-lg"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-1">建立信用紀錄</h4>
                      <p className="text-gray-600 text-sm">有助於建立初期銀行信用紀錄</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 專業提醒 */}
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-2 h-8 bg-orange-500 mr-4"></div>
                專業提醒
              </h3>
              <div className="bg-amber-50 border-2 border-amber-200 rounded-2xl p-8">
                <div className="flex items-start gap-4 mb-6">
                  <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
                    <i className="ri-error-warning-fill text-3xl text-amber-600"></i>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg font-bold text-gray-900 mb-4">申請前請注意</h4>
                    <ul className="space-y-3">
                      <li className="flex items-start gap-3">
                        <i className="ri-alert-line text-amber-600 text-lg mt-0.5 flex-shrink-0"></i>
                        <span className="text-gray-700">青年創業貸款仍需經銀行審查，並非保證核准</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <i className="ri-alert-line text-amber-600 text-lg mt-0.5 flex-shrink-0"></i>
                        <span className="text-gray-700">銀行將評估創業者信用狀況、營運計畫及資金合理性</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <i className="ri-alert-line text-amber-600 text-lg mt-0.5 flex-shrink-0"></i>
                        <span className="text-gray-700">建議將此方案視為創業初期的融資起點，而非長期資金來源</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* 青年創業貸款作業流程 */}
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-2 h-8 bg-orange-500 mr-4"></div>
                青年創業貸款作業流程
              </h3>
              <div className="bg-white rounded-2xl p-8 border-2 border-gray-200">
                <div className="flex flex-col items-center">
                  <div
                    className="w-full flex justify-center cursor-pointer"
                    onClick={() => setIsImageModalOpen(true)}
                  >
                    <img
                      src="https://static.readdy.ai/image/43321df491d4a0e2e55deeaac186a2b1/f0f0b4b885915f8d311e34e48da3a080.png"
                      alt="青年創業貸款作業流程圖"
                      className="rounded-lg shadow-lg hover:shadow-xl transition-shadow"
                      style={{
                        maxWidth: '900px',
                        width: '100%',
                        height: 'auto',
                        display: 'block',
                        imageRendering: 'auto',
                      }}
                    />
                  </div>
                  <p className="text-sm text-gray-500 mt-4">
                    點擊圖片可放大查看完整流程
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-orange-500 to-orange-600">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
            準備好開始您的創業之路了嗎？
          </h2>
          <p className="text-xl text-white/90 mb-8 leading-relaxed">
            讓朋睿專業顧問協助您評估資格、準備文件，提高核貸成功率
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="px-8 py-4 bg-white text-orange-600 text-lg font-semibold rounded-lg hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              免費諮詢
            </Link>
            <Link
              to="/services"
              className="px-8 py-4 bg-transparent text-white text-lg font-semibold rounded-lg border-2 border-white hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
            >
              查看其他方案
            </Link>
          </div>
        </div>
      </section>

      <Footer />
      
      {/* LINE 客服按鈕 */}
      <a
        href="https://line.me/R/ti/p/@678gwbht"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-28 right-6 z-40 w-14 h-14 bg-[#06C755] rounded-full flex items-center justify-center text-white shadow-lg hover:scale-110 transition-transform duration-300 group"
        aria-label="LINE 即時諮詢"
      >
        <i className="ri-line-fill text-2xl"></i>
        <span className="absolute right-16 bg-gray-900 text-white px-3 py-1 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          LINE 即時諮詢
        </span>
      </a>

      {/* 圖片放大 Modal */}
      {isImageModalOpen && (
        <div
          className="fixed inset-0 bg-black/80 z-50 flex items-start justify-center p-4 overflow-auto"
          onClick={() => setIsImageModalOpen(false)}
        >
          <div
            className="relative mt-12 mb-8"
            style={{ minWidth: '320px', width: '90vw', maxWidth: '1400px' }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setIsImageModalOpen(false)}
              className="absolute -top-10 right-0 text-white hover:text-gray-300 transition-colors"
            >
              <i className="ri-close-line text-3xl"></i>
            </button>
            <img
              src="https://static.readdy.ai/image/43321df491d4a0e2e55deeaac186a2b1/f0f0b4b885915f8d311e34e48da3a080.png"
              alt="青年創業貸款作業流程圖（完整）"
              style={{
                width: '100%',
                height: 'auto',
                display: 'block',
                imageRendering: 'auto',
              }}
              className="rounded-lg shadow-2xl"
            />
          </div>
        </div>
      )}
    </div>
  );
}
